import React, { useEffect, useRef, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { canUseMarketingSegment } from '../../utils/segment';
import { BRAND_SWITCHED_EVENT } from '../../services/brandDnaService';
// Registra o namespace de i18n do segmento antes de qualquer tela dele montar.
import '../../i18n/marketingSegment';
import { APP_HOME } from '../../utils/segment';

/** Parâmetros da URL que prendem a tela a uma marca, um produto ou um criativo — saem na troca de marca. */
const BRAND_BOUND_PARAMS = ['marca', 'id', 'criativo', 'produto'];

/**
 * Guarda das rotas /marketing/*: sem acesso ao segmento, volta para o Fashion.
 *
 * Também aplica a troca de marca do seletor do menu: a tela aberta remonta
 * (key) e relê a marca atual; os parâmetros presos à marca antiga saem da
 * URL, e o detalhe de um criativo (que é de uma marca só) volta para Anúncios.
 */
const MarketingSegmentRoute: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const navigate = useNavigate();
  const [generation, setGeneration] = useState(0);
  // Troca que precisou mudar a URL: a tela só remonta depois que a URL nova
  // chega — senão ela relê o ?marca= antigo e volta para a marca anterior.
  const remountAfterNavigation = useRef(false);

  useEffect(() => {
    if (!remountAfterNavigation.current) return;
    remountAfterNavigation.current = false;
    setGeneration((g) => g + 1);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleSwitch = () => {
      if (location.pathname.startsWith('/marketing/anuncio-imagem/criativo/')) {
        remountAfterNavigation.current = true;
        navigate('/marketing/anuncios', { replace: true });
        return;
      }
      const params = new URLSearchParams(location.search);
      if (BRAND_BOUND_PARAMS.some((p) => params.has(p))) {
        BRAND_BOUND_PARAMS.forEach((p) => params.delete(p));
        const search = params.toString();
        remountAfterNavigation.current = true;
        navigate(`${location.pathname}${search ? `?${search}` : ''}`, { replace: true });
        return;
      }
      setGeneration((g) => g + 1);
    };
    window.addEventListener(BRAND_SWITCHED_EVENT, handleSwitch);
    return () => window.removeEventListener(BRAND_SWITCHED_EVENT, handleSwitch);
  }, [location.pathname, location.search, navigate]);

  if (!canUseMarketingSegment(user)) return <Navigate to={APP_HOME} replace />;
  return <Outlet key={generation} />;
};

export default MarketingSegmentRoute;
